export default "__VITE_ASSET__FpkcYrYV__"